import { lazy } from "react";
import { PARTITION } from "../constants/Constants.js";


const NewHomeLayout = lazy(() => import("../layouts/new/NewHomeLayout.js"));
const LandingPage = lazy(() => import("../layouts/new/LandingPage.js"));

/****Layouts*****/
const HomeLayout = lazy(() => import("../layouts/HomeLayout.js"));
const CommonLayout = lazy(() => import("../layouts/CommonLayout.js"));
const QuizBuilderLayout = lazy(() => import("../layouts/QuizBuilderLayout.js"));
const PrivateHomeLayout = lazy(() => import("../layouts/PrivateHomeLayout.js"));
/*****Routes******/

/**Pages*/
const HomeView = lazy(() => import("../views/public/HomeView.js"));
const QuizBuilderHomeView = lazy(() => import("../views/private/quiz_builder/QuizBuilderHomeView.js"));
const QuizLayoutsGridView = lazy(() => import("../views/private/layout/QuizLayoutsGridView.js"));
const QuizLayoutView = lazy(() => import("../views/private/layout/QuizLayoutView.js"));
const ShowAllQuizView = lazy(() => import("../views/private/quiz/ShowAllQuizView.js"));
const PrivateQuizView = lazy(() => import("../views/private/quiz/PrivateQuizView.js"));
const QuizWelcomeView = lazy(() => import("../views/public/QuizWelcomeView.js"));
const QuizAttendView = lazy(() => import("../views/public/QuizAttendView.js"));
const QuizResultView = lazy(() => import("../views/public/result/QuizResultView.js"));




/** V2 */
const V2HomeLayout = lazy(() => import("../layouts/v2/HomeLayout.jsx"));
const V2PublicQuizLayout = lazy(() => import("../layouts/v2/PublicQuizLayout.jsx"));
const V2PrivateQuizLayout = lazy(() => import("../layouts/v2/PrivateQuizLayout.jsx"));
const V2PrivateCommonLayout = lazy(() => import("../layouts/v2/PrivateCommonLayout.jsx"));
const V2QuizLayout = lazy(() => import("../layouts/v2/QuizLayout.jsx"));
const V2QuizScoreLayout = lazy(() => import("../layouts/v2/QuizScoreBoardLayout.jsx"));
const V2ProfileLayout = lazy(() => import("../layouts/v2/ProfileLayout.jsx"));
const V2HelpLayout = lazy(() => import("../layouts/v2/HelpLayout.jsx"));
const V2ErrorPageLayout = lazy(() => import("../layouts/v2/ErrorPageLayout.jsx"));



const V2HomeView = lazy(() => import("../views/v2/public/HomeView.jsx"));
const V2QuizHome = lazy(() => import("../views/v2/public/QuizHome.jsx"));
const V2PublicQuizHomeView =  lazy(() => import("../views/v2/public/quiz/PublicQuizHomeView.jsx"));
const V2ScoreBoardHomeView = lazy(() => import("../views/v2/public/scoreboard/ScoreBoardHomeView.jsx"));
const V2QuizBuilderHomeView = lazy(() => import("../views/v2/private/quiz/builder/QuizBuilderHomeView.jsx"));
const V2LibraryHomeView = lazy(() => import("../views/v2/private/library/LibraryHomeView.jsx"));
const V2PrivatePeopleHome = lazy(() => import("../views/v2/private/people/PrivatePeopleHome.jsx"));
const V2LayoutDetailHomeView = lazy(() => import("../views/v2/private/quiz/layout/LayoutDetailHomeView.jsx"));
const V2QuizControllerHomeView = lazy(() => import("../views/v2/private/quiz/controller/QuizControllerHomeView.jsx"));
const V2QuizResultView = lazy(() => import("../views/v2/public/result/QuizResultView.jsx"));

const V2ProfileHomeView = lazy(() => import("../views/v2/private/profile/ProfileHomeView.jsx"));
const V2HelpHomeView = lazy(() => import("../views/v2/public/help/HelpHomeView.jsx"));
const V2CreateQuizHelpView = lazy(() => import("../views/v2/public/help/CreateQuizHelpView.jsx"));
const V2AttendQuizHelpView = lazy(() => import("../views/v2/public/help/AttendQuizHelpView.jsx"));
const V2RunManualQuizHelpView = lazy(() => import("../views/v2/public/help/RunManualQuizView.jsx"));

const V2BadRequestView = lazy(() => import("../views/v2/common/error/BadRequestView.jsx"));
const V2PageNotFoundView = lazy(() => import("../views/v2/common/error/PageNotFoundView.jsx"));


const ThemeRoutes = [


  {
    path: PARTITION.HOME,
    element: <HomeLayout />,
    children: [
      { path: "", exact: true, element: <HomeView /> },
    ],
  },

  {
    path: "/new",
    element: <NewHomeLayout />,
    children: [
      { path: "/new/landing", exact: true, element: <LandingPage /> },
    ],
  },

  {
    path: PARTITION.QUIZ,
    element: <CommonLayout />,
    children: [
      { path: "/v1/quiz/hm/*", exact: true, element: <QuizWelcomeView/> },
      { path: "/v1/quiz/atnd/*", exact: true, element: <QuizAttendView/> },
      { path: "/v1/quiz/result/*", exact: true, element: <QuizResultView/> },
    ],
  },

  /**private partition */
  {
    path: PARTITION.PVT_BUILDER,
    element: <QuizBuilderLayout />,
    children: [
      { path: "", exact: true, element: <QuizBuilderHomeView /> }
    ],
  },
  {
    path: PARTITION.PVT_LAYOUTS,
    element: <PrivateHomeLayout />,
    children: [
      { path: "", exact: true, element: <QuizLayoutsGridView /> },
      { path: PARTITION.PVT_LAYOUTS + "/*", exact: true, element: <QuizLayoutView /> }
    ],
  },

  {
    path: PARTITION.PVT_QUIZ,
    element: <PrivateHomeLayout />,
    children: [
      { path: "", exact: true, element: <ShowAllQuizView /> },
      { path: PARTITION.PVT_QUIZ + "/*", exact: true, element: <PrivateQuizView /> },
    ],
  },


  /** V2 */

  {
    path: "/",
    element: <V2HomeLayout />,
    children: [
      { path: "", exact: true, element: <V2HomeView /> },
    ],
  },

    {
    path: "/pub",
    element: <V2PublicQuizLayout />,
    children: [
      { path: "/pub/quiz", exact: true, element: <V2PublicQuizHomeView /> },
    ],
  },

  {
    path: "/quiz",
    element: <V2QuizLayout />,
    children: [
      { path: "/quiz/*", exact: true, element: <V2QuizHome /> },
    ],
  },

  {
    path: "/result",
    element: <V2QuizLayout />,
    children: [
      { path: "", exact: true, element: <V2QuizResultView /> },
    ],
  },


  {
    path: "/score",
    element: <V2QuizScoreLayout />,
    children: [
      { path: "/score/*", exact: true, element: <V2ScoreBoardHomeView /> },
    ],
  },
  
  {
    path: "/pvt/qz",
    element: <V2PrivateQuizLayout />,
    children: [
      { path: "", exact: true, element: <V2QuizBuilderHomeView /> },
    ],
  },

  {
    path: "/pvt",
    element: <V2PrivateCommonLayout />,
    children: [
      { path: "/pvt/lbr", exact: true, element: <V2LibraryHomeView /> },
      { path: "/pvt/layout/*", exact: true, element: <V2LayoutDetailHomeView /> },
      { path: "/pvt/quiz/ctrl/*", exact: true, element: <V2QuizControllerHomeView /> },
       { path: "/pvt/people", exact: true, element: <V2PrivatePeopleHome /> },
    ],
  },

  {
    path: "/profile",
    element: <V2ProfileLayout />,
    children: [
      { path: "", exact: true, element: <V2ProfileHomeView /> },
    ],
  },

  {
    path: "/help/",
    element: <V2HelpLayout />,
    children: [
      { path: "", exact: true, element: <V2HelpHomeView /> },
      { path:"create", exact: true, element: <V2CreateQuizHelpView /> },
      { path:"attend", exact: true, element: <V2AttendQuizHelpView /> },
      { path:"manual", exact: true, element: <V2RunManualQuizHelpView /> },
      
    ],
  },



  {
    path: "/error",
    element: <V2ErrorPageLayout />,
    children: [
      { path: "/error/400", exact: true, element: <V2BadRequestView /> },
    ],
  },

  {
    path: "*",
    element: <V2PageNotFoundView />,
  },
  
];

export default ThemeRoutes;
